import React from 'react';
import { Box, HStack, VStack } from 'native-base';
import { Caption } from '~/shared/Typography';
import { useGeneralStyles } from '~/shared/styles';
import Button from '~/shared/Button';
import SegmentedInput from '~/shared/SegmentedInput';
import FooterTemplate from './FooterTemplate';
import { useI18n, useSpringBigStore } from '@springbig/shared';

const LoginTemplate = ({
    codeLength,
    handleSubmit,
    pinError,
    disabled,
    phoneNumber,
    countdown,
    handleResendCode,
    isResendCode,
}: {
    codeLength: number;
    handleSubmit: (value: any) => void;
    pinError: string;
    disabled: boolean;
    phoneNumber: string;
    countdown: number;
    handleResendCode: () => void;
    isResendCode: boolean;
}) => {
    const { merchantName } = useSpringBigStore();
    const gStyle = useGeneralStyles();
    const { t } = useI18n();

    const formatPhoneNumber = (phone: string): string => {
        if (phone) {
            const areaCode = phone?.slice(0, 3);
            const centralOfficeCode = phone?.slice(3, 6);
            const lineNumber = phone?.slice(6);
            return `(${areaCode}) ${centralOfficeCode}-${lineNumber}`;
        } 
        
        return '';
    };

    return (
        <VStack justifyContent="flex-start" flex={1} space={4}>
            <VStack space={4}>
                <VStack>
                    <Caption
                        fontSize="24"
                        fontWeight="bold"
                        fontFamily="Helvetica"
                        color={gStyle.text}
                    >
                        {t('loginTemplate.enter_code_title')}
                    </Caption>
                    <Caption fontFamily="Helvetica" color={gStyle.text}>
                        {t('loginTemplate.enter_code_subtitle', [codeLength])}
                    </Caption>
                </VStack>
                <SegmentedInput
                    codeLength={codeLength}
                    onSubmit={handleSubmit}
                    error={pinError}
                />
                <HStack>
                    <Box
                        alignSelf="center"
                        h="1px"
                        backgroundColor={gStyle.text}
                        flex={1}
                        flexDir="row"
                    />
                    <Caption px={4} textAlign="center" color={gStyle.text}>
                        {t('loginTemplate.or_separator')}
                    </Caption>
                    <Box
                        alignSelf="center"
                        h="1px"
                        backgroundColor={gStyle.text}
                        flex={1}
                        flexDir="row"
                    />
                </HStack>
                <Caption
                    fontFamily="Helvetica"
                    textAlign="center"
                    color={gStyle.text}
                >
                    {!disabled && phoneNumber === ''
                        ? t('loginTemplate.no_phone_number_message')
                        : t('loginTemplate.phone_number_message', [
                              formatPhoneNumber(phoneNumber),
                          ])}
                </Caption>
                <Button
                    fontFamily="Helvetica"
                    bg={gStyle.button_background}
                    style={{ opacity: disabled ? 0.5 : 1 }}
                    _text={{ color: gStyle.button_text }}
                    isDisabled={disabled}
                    onPress={handleResendCode}
                    rounded={"xl"}
                >
                    {disabled && countdown !== 0
                        ? t('loginTemplate.resend_code_countdown', [countdown])
                        : isResendCode ? t('loginTemplate.resend_code') : t('loginTemplate.resend_code_cta')}
                </Button>
            </VStack>
            <FooterTemplate />
        </VStack>
    );
};

export default LoginTemplate;
